import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How far in advance should I book my ride?',
    answer: 'We recommend booking at least 24 to 48 hours in advance to guarantee availability, especially for specific appointment times. However, we do our best to accommodate same-day and urgent requests based on fleet availability. Please call us directly for immediate needs.'
  }, {
    question: 'Do you provide door-to-door or door-through-door service?',
    answer: "We provide 'door-through-door' service. This means our drivers will assist you from inside your home, safely into the vehicle, and escort you all the way to the reception desk or waiting area of your destination. We do not just drop you at the curb."
  }, {
    question: 'Can you transport my electric wheelchair or scooter?',
    answer: 'Yes! Our wheelchair accessible vans are equipped with heavy-duty hydraulic lifts and 4-point Q-Straint tie-down systems that can safely accommodate manual wheelchairs, electric wheelchairs, and mobility scooters. Please mention the type of device when booking so we send the appropriate vehicle.'
  }, {
    question: 'Can a family member or caregiver ride with me?',
    answer: 'Absolutely. One caregiver or family member can ride along at no additional charge. If you have multiple people wishing to accompany you, please let us know during booking so we can ensure there is adequate seating in the dispatched vehicle.'
  }, {
    question: 'Do you accept Medicare or Medicaid?',
    answer: 'We are an approved provider for state Medicaid NEMT programs. Rides must typically be pre-authorized through your Medicaid transportation broker. Standard Medicare (Part B) generally does not cover routine non-emergency transport, but some Medicare Advantage (Part C) plans do. Please check with your insurance provider or call us for guidance.'
  }, {
    question: "What happens if my doctor's appointment runs late?",
    answer: "We understand that medical appointments are unpredictable. If you book a 'Will-Call' return trip, simply call our dispatch when you are finished, and we will send the next available driver. If you booked a specific return time and are running late, please call us as soon as possible so we can adjust the schedule."
  }, {
    question: 'Are your drivers trained in CPR and First Aid?',
    answer: 'Yes. All AccessRide drivers are required to maintain current CPR and First Aid certifications. They also undergo rigorous training in Passenger Assistance Safety and Sensitivity (PASS), defensive driving, and proper wheelchair securement techniques.'
  }, {
    question: 'Do you accommodate service animals?',
    answer: 'Yes, we gladly accommodate ADA-recognized service animals at no extra charge. Please inform us when booking so the driver is prepared. Note that pets or emotional support animals that are not trained service animals must be transported in an appropriate secure carrier.'
  }];
  return <div className="bg-warm-50 min-h-screen pb-20" data-id="element-349">
      {/* Header */}
      <div className="bg-primary-900 text-white py-16" data-id="element-350">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-351">
          <HelpCircle className="w-16 h-16 mx-auto mb-6 text-primary-300" data-id="element-352" />
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-353">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto" data-id="element-354">
            Find answers to common questions about our transportation services,
            booking process, and policies.
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-355">
        <div className="space-y-4" data-id="element-356">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-warm-200 overflow-hidden transition-all duration-200" data-id="element-357">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-inset" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-358">
                <span className="text-lg font-bold text-warm-900 pr-8" data-id="element-359">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-6 h-6 text-primary-600 flex-shrink-0" data-id="element-360" /> : <ChevronDown className="w-6 h-6 text-warm-400 flex-shrink-0" data-id="element-361" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-362">
                <p className="text-warm-600 leading-relaxed border-t border-warm-100 pt-4" data-id="element-363">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>

        {/* Still have questions CTA */}
        <div className="mt-16 bg-secondary-900 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl" data-id="element-364">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-365">
            Still have questions?
          </h2>
          <p className="text-secondary-100 mb-8 max-w-2xl mx-auto text-lg" data-id="element-366">
            Our dispatch team is available 24/7 to answer any specific questions
            you might have about your transportation needs.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-367">
            <a href="tel:5551234567" data-id="element-368">
              <Button size="lg" className="bg-white text-secondary-900 hover:bg-warm-50 w-full sm:w-auto" data-id="element-369">
                Call (555) 123-4567
              </Button>
            </a>
            <Link to="/contact" data-id="element-370">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-secondary-800 w-full sm:w-auto" data-id="element-371">
                Send us a Message
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}